<template>
  <div>
    <HeaderBlock :block="entry.headerBlock" />
    <ContentBlocks :entry="entry" />
  </div>
</template>

<script>
import gql from 'graphql-tag';
import ContentBlocks from '@/components/common/ContentBlocks';
import { ContentBlocksMatrixFragment } from '@/components/common/ContentBlocksMatrixFragment.js';
import HeaderBlock, { HeaderBlockFragment } from '@/components/common/headerBlock/HeaderBlock';
import { SchemaOrgFragment } from '@/components/common/SchemaOrgFragment.gql';

export const ServicePageFragment = gql`
  fragment ServicePageFragment on service_Entry {
    headerBlock {
      ...HeaderBlockFragment
    }
    contentBlocks {
      ...ContentBlocksMatrixFragment
    }
    seoTopics
    ...SchemaOrgFragment
  }
  ${HeaderBlockFragment}
  ${ContentBlocksMatrixFragment}
  ${SchemaOrgFragment}
`;

export default defineNuxtComponent({
  name: 'ServicePage',
  components: { HeaderBlock, ContentBlocks },
  props: {
    entry: {
      type: Object,
      required: true,
    },
    seomatic: {
      type: Object,
      default: () => {},
    },
  },
});
</script>
